/* eslint-disable no-unused-vars */
/* eslint-disable no-unreachable */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// import PieSocket from 'piesocket-js/src/PieSocket';
// import { Bug } from 'react-bootstrap-icons'; // TODO MLH DO NOT NEED?
// import Echo from 'laravel-echo';
// import Pusher from 'pusher-js';

// VENDORS...
import PieSocket from 'piesocket-js';
import axios from 'axios';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
// BRAINBOUT...
import './App.css';
import CategoriesNewGame from './BbCategoriesNewGame';
import BbQuestion from './BbQuestion';
import BbTopic from './BbTopic';
import Guesses from './BbGuesses';
import Explanation from './BbExplanation';
import Attribution from './BbAttribution';
import Scores from './BbScores';
import Rounds from './BbRounds';
import Ads from './BbAds';
import Welcome from './BbWelcome';
import WelcomeBigSpender from './BbWelcomeBigSpender';
import Waiting from './BbWaiting';
import WelcomeTicketHolder from './BbWelcomeTicketHolder';
import CountryCodes from './BbCountryCode';
// const axios = require('axios');

class App extends React.Component {
  constructor(props) {
    super(props);
    this.parseQuestion = this.parseQuestion.bind(this); // maybe unnecessary
    this.handleGuessesChange = this.handleGuessesChange.bind(this);
    this.parseExplanation = this.parseExplanation.bind(this);
    this.parseAttribution = this.parseAttribution.bind(this);

    const urlParams = new URLSearchParams(window.location.search);
    const playerId = urlParams.get('playerid');
    const roomKey = urlParams.has('roomkey')
      ? urlParams.get('roomkey')
      : 'wysisygg';

    // INIT STATE...
    this.state = {
      currentAction: 'welcome',
      isNewbie: true,
      playerId,
      roomKey,
      roomData: [],
      cats: [],
      playerInfo: [],
      countryCode: 'us',
    };
  }

  /**
   * During game initialization, get required data including: game room data,
   * this player data and categories. Categories are initially based on U.S..
   * Also, on Mount, begin listening to the Socket Server Service: Pie Socket.
   */
  async componentDidMount()
  {
    console.log('HELLO. GAME COMPONENT MOUNTED.');
    const { CancelToken } = axios;
    this.source = CancelToken.source();

    // Axios: Use WP API to get required data at application initialization.
    try {
      const [roomData, userData, categoryData] = await axios.all(
        [this.getRoomData(), this.getPlayerData(), this.getCategories()],
        {
          cancelToken: this.source.token,
        },
      );
      this.setState({
        cats: categoryData.data,
        playerInfo: userData.data,
        roomData: roomData.data,
      });
    } catch (err) {
      if (axios.isCancel(err)) {
        console.log(`Notice AXIOS Cancel: ${err.message}`);
      }
      console.log(`AXIOS await all ERROR: ${err.message}`);
    }

    // Listen to the socket server
    if (document.getElementById('root')) {
      this.listenPieSocket();
    }
  }

  /**
   * Player submitted a guess. Also see: onGuessesChildChange
   * @param {string} es The full, litteral, guess selected.
   */
  handleGuessesChange(es)
  {
    this.setState({ currentPlayerGuess: es });
    axios.post('https://www.brainbout.com/wp-json/brainbout/v2/guesses', {
      roomName: this.state.roomData.room_name,
      roomKey: this.state.roomKey,
      playerName: this.state.playerInfo.user_login,
      playerAvatar: null,
      slug: null, // Do not know how this is working, but the correct slug appears in the db TODO MLH
      guess: es,
      playerID: this.state.playerId,
      gameRoomGroup: null,
    })
      .then((response) => {
      })
      .catch((error) => {
        console.log(error);
      });
  }

  /**
   * Get game categories based on Country Code.
   * Add categories to State.
   * Also see: handleCountryCodeSelect.
   * @param {string} cc Country Code
   */
  async getCategoriesWithNewCC(cc = this.state.countryCode)
  {
    const { CancelToken } = axios;
    this.source = CancelToken.source();
    try
    {
      const [categoryData] = await axios.all(
        [this.getCategories(cc)],
        {
          cancelToken: this.source.token,
        },
      );
      this.setState({
        cats: categoryData.data,
        currentAction: 'welcome',
        countryCode: cc,
      });
    } catch (err) {
      // if the request was cancelled
      if (axios.isCancel(err))
      {
        console.log(`Notice AXIOS Cancel: ${err.message}`);
      }
      console.log(`AXIOS ERROR: ${err.message}`);
    }
  }

  /**
   * Using WP API, get categories associated with the Country Code passed.
   * @param {string} s A two character string representing Country Code, ie: US
   * @returns {JSON} A JSON string containing a subset of game categories
   */
  getCategories(s = this.state.countryCode)
  {
    return axios.get(
      `https://www.brainbout.com/wp-json/brainbout/v2/cats/${s}`,
      // { withCredentials: true },
      // { headers: { 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json' } },
    );
  }

  /**
   * Using WP API, get data associated with this player.
   * @returns {JSON} This player data.
   */
  getPlayerData()
  {
    return axios.get(
      `https://www.brainbout.com/wp-json/brainbout/v2/players/${this.state.playerId}`,
    );
  }

  /**
   * Using WP API, get data associated with this game room.
   * @returns {JSON} This room data
   */
  getRoomData() {
    return axios.get(
      `https://www.brainbout.com/wp-json/brainbout/v2/rooms/${this.state.roomKey}`,
    );
  }

  /**
   * Player selected a new Country Code; add it to State.
   * Also see: handleCountryCodeSelect.
   * @param {object} o A two character string (Country Code, ie: fr)
   */
  handleCountryCodeSelect = (o) =>
  {
    this.getCategoriesWithNewCC(o);
  };

  /**
   * Player selected a new game category.
   * @param {object} o Object contains this game room key and the selected category ID
   */
  handleCategorySelect = (o) =>
  {
    axios
      .put(
        `https://www.brainbout.com/wp-json/brainbout/v2/cats/putcat/${o.rmkey}/${o.catid}`,
        // {
        //   headers: {
        //     'Content-Type': 'application/json',
        //     Authorization: `Bearer ${localStorage.getItem('token')}`,
        //   },
        // },
      )
      .then(
        (response) => {
          if (response.status === 200)
          {
            this.setState({ currentAction: 'waiting' });
          }
        },
        (error) => {
          console.log(error);
        },
      );
  };

  /**
   * Set an initial score, of zero, for new a player and for each new game.
   */
  setInitScore()
  {
    axios.post('https://www.brainbout.com/wp-json/brainbout/v2/scores', {
      roomKey: this.state.roomKey,
      playerID: this.state.playerId,
    })
      .then((response) => {
      })
      .catch((error) =>
      {
        console.log(error);
      });
  }

  /**
   * Received a message containing a URL that points to an advertisement (currently an image)
   * @param {object} msgObj A URL
   */
  parseAdvertisement(msgObj) {
    const advertisementURL = msgObj.adSource === undefined ? [] : msgObj.adSource;
    this.setState({
      currentAction: 'advertisement',
      currentAdvertisement: advertisementURL,
    });
  }

  /**
   * Received a message containing the game round number. Think: question number 1,2, or 3...
   * @param {object} msgObj Object contains a number: rounds
   */
  parseRoundCount(msgObj) {
    const rounds = msgObj.rounds === undefined ? [] : msgObj.rounds;
    this.setState({
      currentAction: 'rounds',
      currentRounds: rounds,
    });
  }

  /**
   * Received a message containing scores in this room.
   * @param {object} msgObj Scores
   */
  parseScores(msgObj) {
    const scores = msgObj.scores === undefined ? '' : msgObj.scores;
    this.setState({
      currentAction: 'scores',
      currentScores: scores,
    });
  }

  /**
   * Received a message that explains the answer to the question.
   * @param {object} msgObj Explanation
   */
  parseExplanation(msgObj)
  {
    const explanation = msgObj.explanation === undefined ? {} : msgObj.explanation;
    this.setState({
      currentAction: 'explanation',
      wikiExplanationJson: explanation,
    });
  }

  /**
   * Received a message containing an attribution for this image.
   * @param {object} msgObj Image attribution
   */
  parseAttribution(msgObj) {
    this.setState({
      currentAction: 'attribution',
      wikiAttribution: msgObj,
    });
  }

  /**
   * Received a message containing the question.
   * @param {object} msgObj The Question, Topic, Image URL...
   */
  parseQuestion(msgObj) {
    const itemLabelArray = msgObj.item_label === undefined ? [] : msgObj.item_label;
    // Question uses key 'item_label' BUT Answer uses key 'ans'
    const metaO = msgObj.meta === undefined ? {} : msgObj.meta;
    const mediaURI = metaO.img === undefined ? '' : metaO.img;
    const topic = metaO.catname === undefined ? 'UNKNOWN' : metaO.catname;
    this.setState({
      currentAction: 'question',
      currentQuestion: itemLabelArray,
      currentTopic: topic,
      currentMediaURI: mediaURI,
      currentAnswer: null,
      wikiItemId: null,
      wikiExplanationJson: null,
      wikiAttribution: null,
      isNewbie: false,
      previousScores: this.updateScores(),
    });
  }

  /**
   * Received a message containing the answer.
   * @param {object} msgObj The answer
   */
  parseAnswer(msgObj) {
    const actualAnswer = msgObj.ans === undefined ? '' : msgObj.ans;
    const wikiItemId = msgObj.item === undefined ? '' : msgObj.item;
    this.setState({
      currentAction: 'answer',
      currentAnswer: actualAnswer,
      wikiItemId,
    });
  }

  /**
   * Assign or clear game scoreboard
   * @returns {array} An associative array of player names and scores
   */
  updateScores() {
    if (this.state.currentScores === null) {
      return [];
    }
    return this.state.currentScores;
  }

  /**
   * Listen to the Socket Server Service Pie Socket,
   * (https://www.piesocket.com/)
   */
  listenPieSocket()
  {
    const pieSocket = new PieSocket({
      clusterId: 's9075.nyc1',
      apiKey: 'o53oHKzivLPM5evh5FFWZXFwf5Cc4hPYKo9VbDvD',
      notifySelf: true,
      consoleLogs: false,
      // presence: true,
      // userId: this.state.playerName,
    });

    pieSocket.subscribe(this.state.roomKey).then((channel) =>
    {
      channel.listen('message', (data, meta) => {});

      channel.on('message', (msg) =>
      {
        let dataObj;
        let msgObj;
        try
        {
          dataObj = JSON.parse(msg.data);
        } catch (error)
        {
          console.error(error);
        }
        try
        {
          msgObj = JSON.parse(dataObj.message);
        } catch (error)
        {
          console.error(error);
        }

        // Message contains an action, telling us what to do now.
        const currentAction = msgObj.action !== undefined ? msgObj.action : 'welcome';
        if (currentAction === 'question')
        {
          this.parseQuestion(msgObj);
        } else if (currentAction === 'answer' && !this.state.isNewbie)
        {
          this.parseAnswer(msgObj);
        } else if (currentAction === 'explanation' && !this.state.isNewbie)
        {
          this.parseExplanation(msgObj);
        } else if (currentAction === 'attribution' && !this.state.isNewbie)
        {
          this.parseAttribution(msgObj);
        } else if (currentAction === 'scores' && !this.state.isNewbie)
        {
          this.parseScores(msgObj);
        } else if (currentAction === 'rounds')
        {
          this.parseRoundCount(msgObj);
        } else if (currentAction === 'advertise' && !this.state.isNewbie)
        {
          this.parseAdvertisement(msgObj);
        }
      });
    });
  }

  /**
  * Render React components
  * @returns HTML in the form of React Components
  */
  render() {
    const t = new Date().getUTCSeconds();

    if (this.state.currentAction === 'welcome')
    {
      this.setInitScore();
      if (this.state.roomData.id < 0) {
        // This is a public room.
        return (
          <div className="App">
            <React.StrictMode>
              <Container fluid>
                <Row className="g-0 text-center">
                  <Col xs={12}>
                    <Welcome
                      playerName={this.state.playerInfo.user_login}
                      key="appwelcomepublic"
                      handleCategorySelection={this.handleCategorySelect}
                    />
                  </Col>
                </Row>
              </Container>
            </React.StrictMode>
          </div>
        );
      }
      if (
        parseInt(this.state.playerId, 10)
        !== parseInt(this.state.roomData.player_id, 10)
        && (this.state.roomData.id > 0)
      ) {
        return (
          <div className="App">
            <React.StrictMode>
              <WelcomeTicketHolder
                playerName={this.state.playerInfo.user_login}
                roomName={this.state.roomData.room_name}
                key="appwelcometicketholder"
              />
            </React.StrictMode>
          </div>
        );
      }

      // Must return null.  Placing in else-if does not work
      if (this.state.roomData.length === 0) return null;

      // if (parseInt(this.state.playerId, 10) !== parseInt(this.state.roomData.player_id, 10)) {
      //   return null;
      // }

      return (
        <div className="App">
          <React.StrictMode>
            {this.state.currentAction === 'welcome' ? (
              <div>
                <Container fluid>
                  <Row className="g-0 text-center">
                    <Col xs={12}>
                      <CountryCodes
                        key="appcc"
                        currentCC={this.state.countryCode}
                        handleCountryCodeSelection={this.handleCountryCodeSelect}
                      />
                      <WelcomeBigSpender
                        playerId={this.state.playerId}
                        playerName={this.state.playerInfo.user_login}
                        roomName={this.state.roomData.room_name}
                        roomKey={this.state.roomKey}
                        cats={this.state.cats}
                        playerInfo={this.state.playerInfo}
                        key="appwelcomeprivate"
                        handleCategorySelection={this.handleCategorySelect}
                      />
                    </Col>
                  </Row>
                </Container>
              </div>
            ) : null}
          </React.StrictMode>
        </div>
      );
    }
    /**
     *  QUESTION
     */
    if (this.state.currentAction === 'question')
    {
      if (this.state.currentRounds.rounds_played === 1)
      {
        this.setInitScore();
      }
      return (
        <div className="App">
          <Container>

            <Row className="g-0 text-center">
              <Col xs={12}>
                <Rounds
                  rounds={this.state.currentRounds}
                  key="approundcountplusone"
                />
              </Col>
            </Row>

            <Row className="g-0 text-center">
              <Col xs={12}>
                <BbTopic
                  topic={this.state.currentTopic}
                  key="apptopic"
                />
              </Col>
            </Row>

            <Row className="g-2 text-center">
              <Col xs={12} md={6}>
                <BbQuestion
                  question={this.state.currentQuestion}
                  topic={this.state.currentTopic}
                  mediaURI={this.state.currentMediaURI}
                  key="appquestion"
                />
              </Col>
              <Col xs={12} md={6}>
                <Guesses
                  question={this.state.currentQuestion}
                  onGuessesChildChange={this.handleGuessesChange}
                  key="appguesses"
                />
              </Col>
            </Row>

            <Row className="g-0 text-center">
              <Col xs={12}>
                <div className="bb-timer-wrapper">
                  <section id="bb-timer-section" />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      );
    }
    /**
     * ANSWER
     */
    if (this.state.currentAction === 'answer')
    {
      return (
        <div className="App">
          <Container>

            <Row className="g-0 text-center">
              <Col xs={12}>
                <Rounds
                  rounds={this.state.currentRounds}
                  key="approundcountplusone"
                />
              </Col>
            </Row>

            <Row className="g-0 text-center">
              <Col xs={12}>
                <BbTopic
                  topic={this.state.currentTopic}
                  key="apptopic"
                />
              </Col>
            </Row>

            <Row className="g-2 text-center">
              <Col xs={12} md={6}>
                <BbQuestion
                  question={this.state.currentQuestion}
                  mediaURI={this.state.currentMediaURI}
                  key="appquestion"
                />
                <div className="bb-timer-wrapper">
                  <section id="bb-timer-section" className="timer-hidden" />
                </div>
              </Col>
              <Col xs={12} md={6}>
                <Guesses
                  currentAction={this.state.currentAction}
                  question={this.state.currentQuestion}
                  answer={this.state.currentAnswer}
                  playerGuess={this.state.currentPlayerGuess}
                  key="appguessesii"
                />
              </Col>
            </Row>
          </Container>
        </div>
      );
    }
    /**
     * EXPLANATION
     */
    if (this.state.currentAction === 'explanation')
    {
      return (
        <div className="App">
          <Container>

            <Row className="g-0 text-center">
              <Col xs={12}>
                <Rounds
                  rounds={this.state.currentRounds}
                  key="approundcountplusone"
                />
              </Col>
            </Row>

            <Row className="g-0 text-center">
              <Col xs={12}>
                <BbTopic
                  topic={this.state.currentTopic}
                  key="apptopic"
                />
              </Col>
            </Row>

            <Row className="g-2 text-center">
              <Col xs={12} md={6}>
                <BbQuestion
                  question={this.state.currentQuestion}
                  mediaURI={this.state.currentMediaURI}
                  key="appquestion"
                />
                <div className="bb-timer-wrapper">
                  <section id="bb-timer-section" className="timer-hidden" />
                </div>
              </Col>
              <Col xs={12} md={6}>
                <Explanation
                  wikiItemId={this.state.wikiItemId}
                  wikiExplanationJson={this.state.wikiExplanationJson}
                  key="appexplanation"
                />
              </Col>
            </Row>
          </Container>
        </div>
      );
    }
    /**
     * ATTRIBUTION
     */
    if (this.state.currentAction === 'attribution')
    {
      return (
        <div className="App">
          <Container>

            <Row className="g-0 text-center">
              <Col xs={12}>
                <Rounds
                  rounds={this.state.currentRounds}
                  key="approundcountplusone"
                />
              </Col>
            </Row>

            <Row className="g-0 text-center">
              <Col xs={12}>
                <BbTopic
                  topic={this.state.currentTopic}
                  key="apptopic"
                />
              </Col>
            </Row>

            <Row className="g-2 text-center">
              <Col xs={12} md={6}>
                <BbQuestion
                  question={this.state.currentQuestion}
                  mediaURI={this.state.currentMediaURI}
                  key="appquestion"
                />
                <div className="bb-timer-wrapper">
                  <section id="bb-timer-section" className="timer-hidden" />
                </div>
              </Col>
              <Col xs={12} md={6}>
                <Explanation
                  wikiItemId={this.state.wikiItemId}
                  wikiExplanationJson={this.state.wikiExplanationJson}
                  key="appexplanation"
                />
                <Attribution
                  wikiAttribution={this.state.wikiAttribution}
                  key="appattribution"
                />
              </Col>
            </Row>
          </Container>
        </div>
      );
    }
    /**
     * SCORES
     */
    if (this.state.currentAction === 'scores')
    {
      if (
        typeof this.state.currentRounds !== 'undefined'
        && parseInt(this.state.currentRounds.rounds_played, 10)
        >= parseInt(this.state.currentRounds.max_rounds, 10)
        && parseInt(this.state.roomData.id, 10) > 0
      )
      {
        if (
          parseInt(this.state.playerId, 10)
          === parseInt(this.state.roomData.player_id, 10)
        )
        {
          return (
            <div className="App">
              <Container>

                <Row className="g-0 text-center">
                  <Col xs={12}>
                    <Rounds
                      rounds={this.state.currentRounds}
                      key="approundcountplusone"
                    />
                  </Col>
                </Row>

                <Row className="g-0 text-center">
                  <Col xs={12}>
                    <Scores
                      scores={this.state.currentScores}
                      previousScores={this.state.previousScores}
                      rounds={this.state.currentRounds}
                      playerName={this.state.playerInfo.user_login}
                      key="appscoreboard"
                    />
                  </Col>
                </Row>

                <Row className="g-0 text-center">
                  <Col xs={12}>
                    <CountryCodes
                      key="appcc"
                      currentCC={this.state.countryCode}
                      handleCountryCodeSelection={this.handleCountryCodeSelect}
                    />
                  </Col>
                </Row>

                <Row className="g-0 text-center">
                  <Col xs={12}>
                    <CategoriesNewGame
                      playerId={this.state.playerId}
                      playerName={this.state.playerInfo.user_login}
                      roomName={this.state.roomData.room_name}
                      roomId={this.state.roomData.id}
                      roomKey={this.state.roomKey}
                      cats={this.state.cats}
                      playerInfo={this.state.playerInfo}
                      key="appwelcome"
                      handleCategorySelection={this.handleCategorySelect}
                    />
                  </Col>
                </Row>
              </Container>
            </div>
          );
        }
        return (
          <div className="App">
            <Container>

              <Row className="g-0 text-center">
                <Col xs={12}>
                  <Rounds
                    rounds={this.state.currentRounds}
                    key="approundcountplusone"
                  />
                </Col>
              </Row>
              <Row className="g-0 text-center">
                <Col xs={12}>
                  <Scores
                    scores={this.state.currentScores}
                    previousScores={this.state.previousScores}
                    rounds={this.state.currentRounds}
                    playerName={this.state.playerInfo.user_login}
                    key="appscoreboardii"
                  />
                  <Waiting
                    thisUser={this.state.playerId}
                    gameroomDriver={this.state.roomData.player_id}
                    key="appscorewaiting"
                  />
                </Col>
              </Row>
            </Container>
          </div>
        );
      }
      return (
        <div className="App">
          <Container>

            <Row className="g-0 text-center">
              <Col xs={12}>
                <Rounds
                  rounds={this.state.currentRounds}
                  key="approundcountplusone"
                />
              </Col>
            </Row>
            <Row className="g-0 text-center">
              <Col xs={12}>
                <Scores
                  scores={this.state.currentScores}
                  previousScores={this.state.previousScores}
                  rounds={this.state.currentRounds}
                  playerName={this.state.playerInfo.user_login}
                  key="appscoreboardprivate"
                />
              </Col>
            </Row>
          </Container>

        </div>
      );
    }
    /**
     * WAITING
     */
    if (this.state.currentAction === 'waiting')
    {
      this.setInitScore();
      return (
        <div className="App">
          <Waiting
            thisUser={this.state.playerId}
            gameroomDriver={this.state.roomData.player_id}
            key="appscorewaiting"
          />
        </div>
      );
    }
    /**
     * ADVERTISEMENT
     */
    if (this.state.currentAction === 'advertisement')
    {
      this.state.currentScores = [];
      this.state.previousScores = [];
      this.setInitScore();
      return (
        <div className="App">
          <Ads
            adSource={this.state.currentAdvertisement}
          />
        </div>
      );
    }
    return (
      <div className="App">
        {/* <Bug /> */}
      </div>
    );
  }
}

/**
 * EXPORT THE BIG GAME COMPONENT
 * Also see: index.js That is where the element root can be found.
 */
export default App;

if (document.getElementById('root')) {
  ReactDOM.render(
    <App currentAction="welcome" />,
    document.getElementById('root'),
  );
}

// #region UNUSED Code
// #region OLD LARAVEL SOCKET SERVER Code:

// window.Echo = new Echo({
//   broadcaster: 'pusher',
//   key: 'o53oHKzivLPM5evh5FFWZXFwf5Cc4hPYKo9VbDvD',
//   wssHost: 's9075.nyc1.piesocket.com',
//   enabledTransports: ['ws', 'wss'],
//   cluster: 'piesocket',
// });
// // let NEWchannel = pusher.subscribe(this.state.roomKey);
// window.Echo.channel(this.state.roomKey).listen('message', (e) => {
//   const msgObj = JSON.parse(e.message);
//   const currentAction = msgObj.action !== undefined ? msgObj.action : 'welcome';
//   if (currentAction === 'question') {
//     this.parseQuestion(msgObj);
//   } else if (currentAction === 'answer' && !this.state.isNewbie) {
//     this.parseAnswer(msgObj);
//   } else if (currentAction === 'explanation' && !this.state.isNewbie) {
//     this.parseExplanation(msgObj);
//   } else if (currentAction === 'attribution' && !this.state.isNewbie) {
//     this.parseAttribution(msgObj);
//   } else if (currentAction === 'scores' && !this.state.isNewbie) {
//     this.parseScores(msgObj);
//   } else if (currentAction === 'rounds') {
//     this.parseRoundCount(msgObj);
//   } else if (currentAction === 'advertise' && !this.state.isNewbie) {
//     this.parseAdvertisement(msgObj);
//   } else
//   {
//     console.log(JSON.stringify(msgObj));
//   }
// });

// eslint-disable-next-line react/no-unused-class-component-methods
// listenPubSub() {
//   window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'a03224de-7eb2-4464-8965-96781e227bb8',
//     wsHost: 'sockets.brainbout.com', // 'localhost', // window.location.hostname,
//     wsPort: 6001,
//     disableStats: true,
//     forceTLS: false,
//     wssHost: 'sockets.brainbout.com', // 'localhost', // window.location.hostname,
//     // wssPort: 443,
//     // enabledTransports: ['ws'],
//   });

//   // If you would like to listen for events on a private channel, use the private method
//   // instead.You may continue to chain calls to the listen method to listen for multiple
//   // events on a single channel:
//   // Echo.private(`orders.${this.order.id}`)
//   //     .listen(...)
//   //     .listen(...);
//   // SEE: https://laravel.com/docs/8.x/broadcasting#receiving-broadcasts

//   window.Echo.channel(this.state.roomKey).listen('NewMessage', (e) => {
//     const msgObj = JSON.parse(e.message);
//     const currentAction = msgObj.action !== undefined ? msgObj.action : 'welcome';
//     if (currentAction === 'question') {
//       this.parseQuestion(msgObj);
//     } else if (currentAction === 'answer' && !this.state.isNewbie) {
//       this.parseAnswer(msgObj);
//     } else if (currentAction === 'explanation' && !this.state.isNewbie) {
//       this.parseExplanation(msgObj);
//     } else if (currentAction === 'attribution' && !this.state.isNewbie) {
//       this.parseAttribution(msgObj);
//     } else if (currentAction === 'scores' && !this.state.isNewbie) {
//       this.parseScores(msgObj);
//     } else if (currentAction === 'rounds') {
//       this.parseRoundCount(msgObj);
//     } else if (currentAction === 'advertise' && !this.state.isNewbie) {
//       this.parseAdvertisement(msgObj);
//     }
//   });
// }

// #endregion
// #endregion
